module.exports = __webpack_public_path__ + "images/emoji/dollar.783e6ac2d66bcc0f48e7.png";